import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import PlayButton from '../../common/PlayButton';

import './ChannelRecordCard.scss';

const ChannelRecordCard = ({
  channelRecordId = 0,
  channelRecordImgSrc = '',
  channelRecordTitle = '',
  channelRecord = {}
}) => {
  const { t } = useTranslation();

  return (
    <div className="ChannelRecordCard">
      <Link className="ChannelRecordCardWrap" to={`/detail-tv-content/${channelRecordId}`}>
        <div className="ChannelRecordCard__wrapper">
          <img
            className="ChannelRecordCard__banner"
            src={channelRecord.image.poster}
            alt="ТЕТ HD"
            loading="lazy"
          />
          <div className="ChannelRecordCard__wrapper__content">
            <p className="ChannelRecordCard__type">{'ЗАПИС' || channelRecord.type}</p>
            <div to="/channel/49/Ukrainian" className="ChannelRecordCard__channel">
              <img src={channelRecordImgSrc} alt="ТЕТ HD" loading="lazy" />
            </div>
          </div>
          <PlayButton
            dataContent={t('common.watch')}
            playButtonClassName="ChannelCard__overlay-btn"
          />
        </div>
        <div className="ChannelRecordCard__content">
          <p className="ChannelRecordCard__nameChannel">
            {channelRecordTitle || 'Название фильма'}
          </p>
          <p className="ChannelRecordCard__subscription">
            {channelRecord.subscription || 'Підписка'}
          </p>
        </div>
      </Link>
    </div>
  );
};

ChannelRecordCard.propTypes = {
  channelRecordId: PropTypes.number,
  index: PropTypes.number,
  channelRecordImgSrc: PropTypes.string,
  channelRecordTitle: PropTypes.string,
  channelRecord: PropTypes.shape({
    id: PropTypes.number,
    subscription: PropTypes.string,
    type: PropTypes.string,
    briz_billing_product_info: PropTypes.shape({
      in_favorites: PropTypes.bool,
      is_available: PropTypes.bool,
      is_free: PropTypes.bool
    })
  })
};

export default ChannelRecordCard;

export const ChannelRecordCardSkeleton = () => {
  return (
    <div className="ChannelRecordSkeletonWrap">
      <div className="ChannelRecordCardWrap Skeleton">
        <div className="ChannelRecordCardSkeleton__image" />
        <div className="ChannelRecordCardSkeleton__title" />
        <div className="ChannelRecordCardSkeleton__extra" />
      </div>
    </div>
  );
};
